module.exports = __webpack_public_path__ + "static/help-img-3-5e8b03cf202a130e3961149dbc82603f.svg";